import { Configuration, LogLevel } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_AAD_CLIENT_ID || 'ccef1f6a-8f76-4714-a0d8-404c73d5dee0';
const tenantId = process.env.REACT_APP_AAD_TENANT_ID || 'd309a9f4-2d5e-4d65-9ea9-6950cec1a1fe';
const redirectUri = process.env.REACT_APP_REDIRECT_URI || window.location.origin + '/auth/callback';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
      },
      logLevel: LogLevel.Error,
    },
  },
};

// Scopes for different API calls
export const loginScopes = ['User.Read'];

export const graphScopes = ['User.Read', 'Mail.Send'];

export const dataverseScopes = [
  'https://saragossa.crm11.dynamics.com/user_impersonation',
];
